/* Праздничные дни (кроме совпадающих с сб и вс) */
export const holidays = [
  //2023
  '02.01.2023',
  '03.01.2023',
  '04.01.2023',
  '05.01.2023',
  '06.01.2023',
  '23.02.2023',
  '24.02.2023',
  '08.03.2023',
  '01.05.2023',
  '08.05.2023',
  '09.05.2023',
  '12.06.2023',
  '06.11.2023',
  //2024
  '01.01.2024',
  '02.01.2024',
  '03.01.2024',
  '04.01.2024',
  '05.01.2024',
  '08.01.2024',
  '23.02.2024',
  '08.03.2024',
  '29.04.2024',
  '30.04.2024',
  '01.05.2024',
  '09.05.2024',
  '10.05.2024',
  '12.06.2024',
  '04.11.2024',
  '30.12.2024',
  '31.12.2024',
  //2025
  '01.01.2025',
  '02.01.2025',
  '03.01.2025',
  '06.01.2025',
  '07.01.2025',
  '08.01.2025',
  '01.05.2025',
  '02.05.2025',
  '08.05.2025',
  '09.05.2025',
  '12.06.2025',
  '13.06.2025',
  '03.11.2025',
  '04.11.2025',
  '31.12.2025',
  //2026
  '01.01.2026',
  '02.01.2026',
  '05.01.2026',
  '06.01.2026',
  '07.01.2026',
  '08.01.2026',
  '09.01.2026',
  '23.02.2026',
  '09.03.2026',
  '01.05.2026',
  '11.05.2026',
  '12.06.2026',
  '04.11.2026',
  '31.12.2026',
];

/* Переносы (когда сб или вс рабочие) */
export const workDays = [
  //2024
  '27.04.2024',
  '02.11.2024',
  '28.12.2024',
  //2025
  '01.11.2025',
];
